"use strict";

exports.__esModule = true;
exports.default = decodeB64ToUint8Array;
var _window = _interopRequireDefault(require("global/window"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var atob = function atob(s) {
  return _window.default.atob ? _window.default.atob(s) : Buffer.from(s, 'base64').toString('binary');
};
function decodeB64ToUint8Array(b64Text) {
  var decodedString = atob(b64Text);
  var array = new Uint8Array(decodedString.length);
  for (var i = 0; i < decodedString.length; i++) {
    array[i] = decodedString.charCodeAt(i);
  }
  return array;
}